import { render, staticRenderFns } from "./MatchDay.vue?vue&type=template&id=801f83a6"
import script from "./MatchDay.vue?vue&type=script&lang=js"
export * from "./MatchDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports